import { useEffect, useRef } from "react";

/**
 * Subscribe to the global `garu:book-demo` event so any page that
 * mounts a {@link DemoScheduler} modal opens it when the shared
 * footer CTA fires the event.
 *
 * The Footer (which is rendered on every page) doesn't own modal
 * state. Instead it dispatches a window-level CustomEvent and the
 * page that has a DemoScheduler subscribes here. This keeps the
 * Footer dependency-free and lets each page decide what "Book a
 * demo" means for its surface.
 *
 * The handler ref pattern lets callers pass an inline arrow without
 * re-binding the listener on every render.
 */
export function useBookDemoEvent(open: () => void) {
  const handlerRef = useRef(open);
  handlerRef.current = open;

  useEffect(() => {
    const handler = () => handlerRef.current();
    window.addEventListener("garu:book-demo", handler);
    return () => window.removeEventListener("garu:book-demo", handler);
  }, []);
}
